/* eslint-disable consistent-return */
import { IStore } from 'store/types';

export const selectPayouts = () => (state: IStore) => state.collections.payouts?.data;

export const selectTotalCountPayouts = () => (state: IStore) => state.collections.payouts?.total;
